import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import EventLabel from '../../components/EventLabel/EventLabel';

const focusInputSelector =
  '.react-grid-layout input:not(readonly):not(disabled), .react-grid-layout textarea:not(readonly):not(disabled), .react-grid-layout select:not(readonly):not(disabled)';

export const GroupRegistration = observer(props => {
  const [showEventFull, setShowEventFull] = useState(false);

  const { settings, triggerValidation, checkConditions, createOrder, current, environment, orders, checkEventAvailability, getFilteredValidations } = props;
  const { hidden, maxCount = 0 } = settings;

  useEffect(() => {
    (async () => {
      try {
        const isAvailable = await checkEventAvailability(environment.eventId);
        setShowEventFull(!isAvailable);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [checkEventAvailability]);

  const handleClick = useCallback(async () => {
    try {
      const isAvailable = await checkEventAvailability(environment.eventId);
      const isValid = getFilteredValidations()?.length === 0;

      if (isValid && isAvailable) {
        runInAction(() => {
          triggerValidation(false);
          const shouldFocus = current.activePage == settings.returnPage;
          current.activePage = settings.returnPage;

          createOrder();
          checkConditions();
          
          document.getElementById('body').scrollTop = 0;
          // if (shouldFocus) {
          //   document.querySelector(focusInputSelector).focus();
          // }
        });
      } else if (!isAvailable && isValid) {
        setShowEventFull(!isAvailable);
      } else {
        triggerValidation();
      }
    } catch (error) {
      triggerValidation();
      console.error(error);
    }
  }, [checkEventAvailability, triggerValidation, settings.returnPage, createOrder, environment.eventId, checkConditions, current.activePage]);

  const labelName = useMemo(() => {
    if (maxCount > 0 && orders.length >= maxCount) return 'MaxGroupCountReached';
    if (showEventFull) return 'MainEventFull';
    return 'AddNewOrderBtn';
  }, [maxCount, orders.length, showEventFull]);

  if (hidden) return null;

  return (
    <>
      <button className="cms-button" disabled={(maxCount > 0 && orders.length >= maxCount) || showEventFull} onClick={handleClick}>
        <PersonAddIcon />
        <EventLabel name={labelName} groupName={'Cms.GroupModule'} />
      </button>
    </>
  );
});
